import errorMessages from "utils/validation/errorMessages";
import { emailSchema, emailSchemaV2, phoneOptionalSchema, phoneRequiredSchema, phoneRequiredSchemaV2, select2RequiredSchema, stringOptionalSchema, stringRequiredSchema } from "utils/validation/validationHelpers";
import { array, object, string } from 'yup';

const addTherapistFormSchemaV2 = object().shape({
	firstname: stringRequiredSchema,
	lastname: stringRequiredSchema,
	// username: stringRequiredSchema,
	email: emailSchemaV2,
	discipline_id: select2RequiredSchema, 
	designation_id: select2RequiredSchema,
	assigned_client_category: array().required(errorMessages.required).of(select2RequiredSchema).min(1, errorMessages.required),
	type: stringRequiredSchema,
	phone: phoneRequiredSchemaV2,
	timezone: select2RequiredSchema,
	// address1: stringRequiredSchema,
	// address2: stringRequiredSchema,
	// city: stringRequiredSchema,
	// postal_code: stringRequiredSchema, 
	// registration_number: stringOptionalSchema,
	// insurance_policy_number: stringOptionalSchema,
	// calendly_link: stringOptionalSchema,
	// self_description: stringOptionalSchema,
	// profile_picture: stringOptionalSchema.url(errorMessages.url),
	// email_signature: stringOptionalSchema,
	// signature_img: stringOptionalSchema.url(errorMessages.url),
	// status: stringRequiredSchema,
	documents: array().of(object().shape({
		attachment_key: stringRequiredSchema,
		attachment_name: stringRequiredSchema
	})),
});

export default addTherapistFormSchemaV2;